import { networkRequest } from "./core";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const loginService = (email, pwd) => {
    return networkRequest.post(`${API_URL}/user/login`, {
        "email": email,
        "password": pwd
    }).then((res) => {
        return res
    }
    ).catch((err) => {
        return Promise.reject(err)
    })
}

const forgotPasswordService = async (email) => {
    try {
        const response = await networkRequest.post(`${API_URL}/user/forgot-password?email=${email}`,{})
        return response

    } catch(error){
        return await Promise.reject(error);
    }
}
export const userAuthServices = { loginService,forgotPasswordService }

